import { Injectable } from '@angular/core';
declare var $: any;

@Injectable()
export class Helpers {

  setDataTableSearchDelay() {
    var searchDelay = null;

    setTimeout(function () {
      $('.dataTables_filter input')
        .off('keyup.DT search.DT input.DT paste.DT cut.DT')
        .on('keyup.DT search.DT input.DT paste.DT cut.DT', function (e) {
          var search = $('div.dataTables_filter input').val();
          clearTimeout(searchDelay);

          searchDelay = setTimeout(function () {
            if (search != null) {
              $.fn.dataTable.tables({ api: true, visible: true }).search(search).draw();
            }
          }, 1000);
        });
    }, 1000);
  }

  getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach(key => {

      if (object[key] != null) {

        if (object[key].constructor.name == "Array") {
          let i = 0;
          object[key].forEach(function (arr) {
            formData.append(`${key}[${i}]`, arr);
            i++;
          })
        }

        else if (object[key] instanceof Object && object[key].constructor.name != "File") {
          for (const subKey in object[key]) {
            if (object[key].hasOwnProperty(subKey)) {
              formData.append(`${key}.${subKey}`, object[key][subKey]);
            }
          }
        }
        else {
          formData.append(key, object[key]);
        }
      }
    });
    return formData;
  }

}
